export default __webpack_public_path__ + "4c735eb6c77c90d75ac306531fda8059.svg";